<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  beforeMount(){
    document.title = "Play.Works is the #1 provider of CTV Games and Original TV Channels."
  },
}
</script>

<style src="./main.css"></style>